import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {ShiftTypeModel} from '@/libs/Api';
import {ShiftTypesDataService} from '@/libs/shift-types/shift-types-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const shiftTypesStore = registerCrudStore<ShiftTypeModel, ShiftTypeModel>(BusinessModule.ShiftType, new ShiftTypesDataService());
